import React from "react";
export function PublicLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="min-h-screen w-full bg-paper" data-id="element-157" data-mp="9mes4jxlevxw">
      <header className="bg-waves text-white" data-id="element-158" data-mp="9kttoj85qsur">
        <div className="flex h-1" aria-hidden="true" data-id="element-159" data-mp="4mik89lrykd2">
          <span className="flex-1 bg-brgreen" data-id="element-160" data-mp="4nagznr3yo4x" />
          <span className="flex-1 bg-bryellow" data-id="element-161" data-mp="3vtv10niqwvsg" />
          <span className="flex-1 bg-saffron" data-id="element-162" data-mp="3vv65yqnxg9l5" />
          <span className="flex-1 bg-ingreen" data-id="element-163" data-mp="xc8z4kv8dqa8" />
        </div>
        <div className="mx-auto flex max-w-2xl items-center justify-between gap-4 px-5 py-4" data-id="element-164" data-mp="xdsfebgw01c0">
          <div data-id="element-165" data-mp="sepnlspx3rlz">
            <p className="text-[15px] font-bold" data-id="element-166" data-mp="nlwiv4ug8j9w">Engineering Entrepreneurship Challenge</p>
            <p className="text-xs text-white/60" data-id="element-167" data-mp="njjr5zyw2ujn">Link School of Business × Mahindra University × Circuit Launch</p>
          </div>
          <span className="hidden text-xs text-white/60 sm:block" data-id="element-168" data-mp="1g2qsmrnw0pwn">Demo Day · Oct 13</span>
        </div>
      </header>
      <main className="mx-auto max-w-2xl px-5 py-10" data-id="element-169" data-mp="1bafqrj9l6u1g">{children}</main>
    </div>;
}